var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 col-xl p-0" }, [
    _c("div", { staticClass: "row align-items-center no-gutters" }, [
      _vm.showAgents
        ? _c(
            "div",
            {
              staticClass: "col-12 col-md-5 col-lg-3 px-1 agents-filter",
              attrs: { id: "agent-filter" },
            },
            [
              _c("agents-select", {
                ref: "selectAgent",
                attrs: {
                  value: _vm.currentAgent,
                  "current-username": _vm.loggedInAgent,
                  multiple: false,
                  "material-design": false,
                  "space-classes": "col-12 p-0 mt-3",
                  "is-application-board": _vm.isApplicationBoard,
                  "agent-usernames-to-include": _vm.agentUsernamesToInclude,
                  "has-active-filters": _vm.hasActiveFilters,
                },
                on: { change: _vm.agentSelected },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-12 d-flex flex-row client justify-content-start justify-content-md-end align-items-center search-side",
          class: _vm.showAgents ? "col-md-7 col-lg-9" : "",
        },
        [
          _c(
            "div",
            { staticClass: "filters mb-2" },
            [
              _c("application-list-filters", {
                ref: "applicationFilters",
                attrs: { "is-property-account": _vm.isPropertyAccount },
                on: { change: _vm.handleFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-inner-addon mr-2 mb-2 w-90 w-md-auto" },
            [
              _c("i", {
                staticClass: "fa fa-search",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText",
                  },
                ],
                staticClass: "form-control search-clients ignore-popover",
                attrs: {
                  id: "applications-search-client",
                  type: "search",
                  placeholder: _vm.$t("application.listing.searchForClients"),
                  autocomplete: "off",
                  "data-lpignore": "true",
                },
                domProps: { value: _vm.searchText },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchText = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "d-none",
                  attrs: { for: "applications-search-client" },
                },
                [_vm._v(_vm._s(_vm.$t("application.listing.searchForClients")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mb-2 d-lg-flex flex-lg-row d-none" }, [
            _c(
              "button",
              {
                staticClass: "import-clients btn btn-white btn-sm",
                on: {
                  click: function ($event) {
                    return _vm.handleClick("import")
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("application.listing.importApplications")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "add-client btn btn-primary btn-sm ml-1",
                attrs: { disabled: _vm.isViewOnly },
                on: {
                  click: function ($event) {
                    return _vm.handleClick("add")
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("application.listing.addApplication")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown d-flex flex-row d-lg-none" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu" }, [
              _c("div", { staticClass: "dropdown-item clickable wide px-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white",
                    on: {
                      click: function ($event) {
                        return _vm.handleClick("import")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("application.listing.importApplications")
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-item clickable wide px-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white",
                    attrs: { disabled: _vm.isViewOnly },
                    on: {
                      click: function ($event) {
                        return _vm.handleClick("add")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("application.listing.addApplication")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-xl-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }